import {Injectable, ViewContainerRef} from '@angular/core';
@Injectable()
export class ViewService {
    private _viewContainerRef?: ViewContainerRef;

    get viewContainerRef(): ViewContainerRef | undefined {
        return this._viewContainerRef;
    }
    set viewContainerRef(value: ViewContainerRef | undefined) {
        this._viewContainerRef = value;
    }
}